// React
import React, { Component } from 'react';
import { CategorySearch } from '@appbaseio/reactivesearch';

class SearchBar extends Component {
  render() {
    const { dataFields, primaryField, reactSensors, resultCount } = this.props;

    const customQuery = (value, props) => {
      if(typeof(value) === "undefined" || value.length === 0) {
        return {
          query: {
            match_all: {}
          }
        }
      }

      return {
        query: {
          query_string: {
            fields: props.dataField,
            query: value
          }
        }
      }
    };

    return (
      <div className="search-input">
        <CategorySearch
          componentId="Query"
          dataField={dataFields}
          categoryField={primaryField}
          highlightField={primaryField}
          placeholder={window.Drupal.t("Enter keywords...")}
          customQuery={customQuery}
          URLParams={true}
          filterLabel="Query"
          showIcon={false}
          react={{
            and: reactSensors
          }}
        />
        <span className="result-count">{window.Drupal.t("@count results", { '@count': resultCount })}</span>
      </div>
    )
  }
}

export default SearchBar;
